import { AxiosInstance } from 'axios';
import {
  HousekeepingReportServiceModel,
  initHousekeepingReportService,
} from './HouseKeepingReport';
import {
  HouseKeepingRoomServiceStatusServiceModel,
  initServiceStatusRootService,
} from './RoomServiceStatus';

export interface HouseKeepingServiceModel {
  housekeepingReport: HousekeepingReportServiceModel;
  roomServiceStatus: HouseKeepingRoomServiceStatusServiceModel;
}

export const initHouseKeepingService = (axios: AxiosInstance): HouseKeepingServiceModel => ({
  housekeepingReport: initHousekeepingReportService(axios),
  roomServiceStatus: initServiceStatusRootService(axios),
});
